import { createApi } from "@reduxjs/toolkit/query";
import { CancelSubscriptionPayload } from "components/pages/AccountComponent/BillingComponent/CancelSubscription/types";

import { baseCustomFetchBase } from "../service/customFetchBase";

const subscriptionApi = createApi({
  reducerPath: "subscriptionApi",
  baseQuery: baseCustomFetchBase,
  endpoints: (builder) => ({
    getSubscriptionStatus: builder.mutation<any, any>({
      query: () => ({
        url: "/emergency/subscription/status",
        method: "GET",
      }),
    }),
    cancelSubscription: builder.mutation<
      any,
      { data: CancelSubscriptionPayload }
    >({
      query: (data) => ({
        url: "/emergency/subscription/cancel",
        method: "POST",
        body: data,
      }),
    }),
    resumeSubscription: builder.mutation<any, any>({
      query: () => ({
        url: "/emergency/subscription/resume",
        method: "POST",
      }),
    }),
  }),
});

export default subscriptionApi;

export const { getSubscriptionStatus, cancelSubscription, resumeSubscription } =
  subscriptionApi.endpoints;
